import m from "./en/emojiReactions.json.es.js";
import o from "./en/integrations.json.es.js";
import p from "./en/notifications.json.es.js";
import a from "./en/responses.json.es.js";
import f from "./en/userMeetingTypes.json.es.js";
import c from "./it/emojiReactions.json.es.js";
import i from "./it/integrations.json.es.js";
import g from "./it/notifications.json.es.js";
import j from "./it/responses.json.es.js";
import R from "./de/emojiReactions.json.es.js";
import t from "./de/integrations.json.es.js";
import l from "./de/notifications.json.es.js";
import P from "./de/responses.json.es.js";
import I from "./es/emojiReactions.json.es.js";
import s from "./es/integrations.json.es.js";
import D from "./es/notifications.json.es.js";
import E from "./es/responses.json.es.js";
import K from "./pl/emojiReactions.json.es.js";
import n from "./pl/integrations.json.es.js";
import d from "./pl/notifications.json.es.js";
import k from "./pl/responses.json.es.js";
import T from "./ko/emojiReactions.json.es.js";
import r from "./ko/integrations.json.es.js";
import u from "./ko/notifications.json.es.js";
import x from "./ko/responses.json.es.js";
import y from "./pt/emojiReactions.json.es.js";
import e from "./pt/integrations.json.es.js";
import M from "./pt/notifications.json.es.js";
import b from "./pt/responses.json.es.js";
const no = {
  en: {
    responses: a,
    notifications: p,
    emojiReactions: m,
    integrations: o,
    userMeetingTypes: f
  },
  it: {
    responses: j,
    notifications: g,
    emojiReactions: c,
    integrations: i
  },
  de: {
    responses: P,
    notifications: l,
    emojiReactions: R,
    integrations: t
  },
  es: {
    responses: E,
    notifications: D,
    emojiReactions: I,
    integrations: s
  },
  pl: {
    responses: k,
    notifications: d,
    emojiReactions: K,
    integrations: n
  },
  ko: {
    responses: x,
    notifications: u,
    emojiReactions: T,
    integrations: r
  },
  pt: {
    responses: b,
    notifications: M,
    emojiReactions: y,
    integrations: e
  }
}, ro = {
  en: o,
  it: i,
  de: t,
  es: s,
  pl: n,
  ko: r,
  pt: e
};
export {
  no as commonTranslations,
  ro as l10nIntegrations
};
